import React from "react";
import * as Styles from "../../../../../common-deprecated/styles/v2/lexus/custom/SelectPane";
import * as Text from "../../../../../common-deprecated/styles/v2/lexus/utilities/Text";
import { IconWrapper } from "../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import { useCompareV2Selector } from "../../../redux/store";
import Icon from "../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { isRTL } from "../../../../../common-deprecated/settings/utils/commonSettingUtils";

type ModelPanelPropsType = {
    setModel: (modelId: string) => void;
};

const ModelPanel = (props: ModelPanelPropsType): JSX.Element => {
    const { setModel } = props;
    const availableCarsData = useCompareV2Selector((state) => state.newCarCompare.available);
    const models = availableCarsData.map((m) => ({ modelName: m.modelName, modelId: m.modelId }));
    const settings = useCompareV2Selector((state) => state.commonSettings);

    return (
        <Styles.Panel>
            <Styles.PanelScroll>
                {models.map((model) => {
                    return (
                        <Styles.PanelItem key={model.modelId} onClick={() => setModel(model.modelId)}>
                            <Text.Body>{model.modelName}</Text.Body>
                            <IconWrapper>
                                <Icon variant={isRTL(settings) ? "arrowLeft" : "arrowRight"} />
                            </IconWrapper>
                        </Styles.PanelItem>
                    );
                })}
            </Styles.PanelScroll>
        </Styles.Panel>
    );
};

export default ModelPanel;
